import React from 'react';
import { offer } from '../data/offer';
const legalLinks = ['Mentions légales', 'Conditions générales de vente', 'Politique de confidentialité'];
export function Footer() {
  return <footer className="w-full border-t border-warm-line bg-creme-dark" data-id="element-104" data-mp="32oe2m2kq2nec">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 md:px-10" data-id="element-105" data-mp="32m1ch24t96q7">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12" data-id="element-106" data-mp="36pz8v52r43fk">
          <div className="lg:col-span-5" data-id="element-107" data-mp="3uesclnpm7fkq">
            <p className="font-serif text-lg font-semibold text-graphite" data-id="element-108" data-mp="3uftpzyu3se5m">
              {offer.name} — {offer.method}
            </p>
            <p className="mt-3 max-w-prose text-sm leading-relaxed text-warm" data-id="element-109" data-mp="3lelzw41qqjmm">
              Pour les coachs qui préfèrent un cadre solide aux promesses
              spectaculaires.
            </p>
          </div>

          <nav aria-label="Liens légaux et contact" className="lg:col-span-7" data-id="element-110" data-mp="29yxe3g083qne">
            <ul className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-graphite-mid" data-id="element-111" data-mp="2ey09e8qeiii6">
              <li data-id="element-112" data-mp="3l9k5dbpy7lcr">
                <a href={`mailto:${offer.supportEmail}`} className="underline decoration-warm-line underline-offset-4 transition-colors duration-150 ease-out hover:text-graphite" data-id="element-113" data-mp="3l90lvqkngowm">
                  {offer.supportEmail}
                </a>
              </li>
              {legalLinks.map(link => <li key={link} data-id="element-114" data-mp="3q7bww4mol5gf">
                  <a href="#offre" className="underline decoration-warm-line underline-offset-4 transition-colors duration-150 ease-out hover:text-graphite" data-id="element-115" data-mp="82qsbsqetttq">
                    {link}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-14 border-t border-warm-line pt-8" data-id="element-116" data-mp="cv1uz3cjbtpz">
          <p className="max-w-3xl text-xs leading-relaxed text-warm" data-id="element-117" data-mp="qt03hs46cvxk">
            Contenu à visée éducative et informative destiné à des coachs
            formés. Il ne remplace pas un avis médical, psychiatrique ou
            psychologique. Le coaching n’est pas une thérapie. Aucun résultat
            n’est garanti. Licence d’usage individuel.
          </p>
          <p className="mt-6 text-xs text-warm-light" data-id="element-118" data-mp="ys3bc32baeur">
            © 2026 {offer.name}. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>;
}